module.exports = __webpack_public_path__ + "static/media/product-2-side.ee51697a.jpg";